exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-601f56a1] {\n    margin: 0;\n    padding-left: 1rem;\n}\n.wrap[data-v-601f56a1] {\n    word-wrap: break-word;\n    word-break: break-all;\n    white-space: normal;\n}\n", ""]);

// exports
